import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'submit',
    'dateSelect',
    'timeSelect',
    'peopleSelect',
    'displayDate',
    'datePickerWrapper',
    'datePicker',
  ]

  initialize() {
    this.state = {
      active: false,
      url: 'https://www.opentable.com.mx/restref/client/?',
      params: {
        rid: this.element.dataset.openTableId,
        restref: this.element.dataset.openTableId,
        partysize: this.peopleSelectTarget.value,
        datetime: false,
        lang: 'en-US',
      },
    }
  }

  connect() {
    this.setUp()
    this.events()
  }

  setUp() {
    this.setDateTime()
    this.initDatePicker()
  }

  events() {
    this.element.addEventListener('click', this.checkOutsideClick.bind(this))
    this.submitTarget.addEventListener('click', this.buildUrl.bind(this))
    this.timeSelectTarget.addEventListener('change', this.handleTimeChange.bind(this))
    this.peopleSelectTarget.addEventListener('change', this.handlePeopleChange.bind(this))
    this.displayDateTarget.addEventListener('focus', this.setActive.bind(this))
    this.datePickerTarget.addEventListener('click', this.moveToNextMonth.bind(this))
  }

  removeEvents() {
    this.element.removeEventListener('click', this.checkOutsideClick.bind(this))
    this.submitTarget.removeEventListener('click', this.buildUrl.bind(this))
    this.timeSelectTarget.removeEventListener('change', this.handleTimeChange.bind(this))
    this.peopleSelectTarget.removeEventListener('change', this.handlePeopleChange.bind(this))
    this.displayDateTarget.removeEventListener('focus', this.setActive.bind(this))
    this.datePickerTarget.removeEventListener('click', this.moveToNextMonth.bind(this))
  }

  initDatePicker() {
    jQuery(this.datePickerTarget).datepicker({
      numberOfMonths: 1,
      dateFormat: 'MM d, yy',
      minDate: new Date(),
      maxDate: '+1Y',
      prevText: '',
      nextText: '',
      altField: this.dateSelectTarget,
      altFormat: 'yy-mm-dd',
      dayNamesMin: $.datepicker.regional[$('#locale').val()].dayNamesMin,
      onSelect: (value, instance) => {
        this.setDisplayDate(value)
        this.setDateTime()
        this.clearActive()
      },
    })
  }

  setDateTime() {
    const date = this.dateSelectTarget.value
    const time = this.timeSelectTarget.value
    const dateTime = `${date}T${time}`
    this.state.params.datetime = dateTime
  }

  setDisplayDate(dateTime) {
    this.displayDateTarget.value = dateTime
  }

  handleDateChange() {
    this.setDateTime()
  }

  handleTimeChange() {
    this.setDateTime()
  }

  handlePeopleChange() {
    this.state.params.partysize = this.peopleSelectTarget.value
  }

  setActive() {
    if (!this.state.active) {
      this.datePickerWrapperTarget.classList.add('is-active')
      this.state.active = true
    }
  }

  clearActive() {
    if (this.state.active) {
      this.datePickerWrapperTarget.classList.remove('is-active')
      this.state.active = false
    }
  }

  checkOutsideClick(event) {
    if (this.state.active) {
      const module = this.element
      const target = event.target
      const isWithinModule = module.contains(target)
      const isDatePickerNavigtionElement = (
        target.classList.contains('ui-icon') ||
        target.classList.contains('ui-datepicker-prev') ||
        target.classList.contains('ui-datepicker-next')
      );
      if (!isWithinModule && !isDatePickerNavigtionElement) {
        this.clearActive()
      }
    }
  }

  buildUrl(event) {
    event.preventDefault()
    event.stopPropagation()
    const queryString = jQuery.param(this.state.params)
    const urlWithQueryString = `${this.state.url}${queryString}`
    window.open(urlWithQueryString, '_blank')
  }

  disconnect() {
    this.removeEvents()
    this.clearActive()
  }
}